import { initState } from "../../TypesAndConstants/const";
import {
  AppState,
  dispatchAction,
  MenuActions,
} from "../../TypesAndConstants/types";
export const Reducer = (
  state: AppState = initState,
  action: dispatchAction
): AppState => {
  switch (action.type) {
    case "set_user_brushes":
      return { ...state, userBrushes: action.value };
    case "load_Brush":
      return { ...action.value };
    case "close_imagemodal":
      return { ...state, imageModalOpen: action.value };
    case "set_color_speed":
      return { ...state, colorTransitionSpeed: action.value };
    case "set_colorfill_mode":
      return { ...state, isColorfillMode: action.value, isColorSelect: false };
    case "set_colorselect_mode":
      return { ...state, isColorSelect: action.value, isColorfillMode: false };
    case "set_color_animated":
      return { ...state, colorIsAnimated: action.value };
    case "set_palette_used":
      return { ...state, isPaletteUsed: action.value };
    case "set_active_brush":
      return { ...state, activeBrush: action.value };
    case "set_brush_animated":
      return { ...state, animation: action.value };
    case "set_global_color":
      return {
        ...state,
        globalColorData: action.value,
      };
    case "set_shape_images":
      const localArt = [...state.shapeImages];
      localArt.push(action.value);
      return { ...state, shapeImages: localArt };
    case "set_image":
      const newImage = Object.assign({}, {...state.images});
      newImage[action.value[0]] = action.value[1];
      return {
        ...state,
        images: newImage,
      };
    case "set_active_menu":
      return {
        ...state,
        cachedColorData:
          action.value === "color"
            ? {
                data: state.globalColorData,
                color: state.brushColor,
              }
            : undefined,
        currentActiveMenu: action.value as MenuActions,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_brush_playback_speed":
      return {
        ...state,
        brushPlaybackRate: action.value,
      };
    case "set_brush_color":
      return {
        ...state,
        brushColor: action.value,
      };
    case "set_colorbar_collapsed":
      return {
        ...state,
        brushbarIsCollapsed: true,
        colorBarIsCollapsed: action.value,
      };
    case "set_brushbar_collapsed":
      return {
        ...state,
        brushbarIsCollapsed: action.value,
        colorBarIsCollapsed: true,
      };
    case "set_canvas_resolution":
      return {
        ...state,
        CanvasSizeData: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_dimensions":
      return {
        ...state,
        dimensions: action.value,
      };
    case "set_brush_count":
      return {
        ...state,
        brushCount: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_brush_speed":
      console.info("setting brush speed " + action.value)
      return {
        ...state,
        brushSpeed: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_brush_size":
      return {
        ...state,
        brushSize: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_brush_type":
      return {
        ...state,
        brushType: action.value,
        isColorSelect: false,
        isColorfillMode: false,
        brushSpeed: action.value === "growshrink" ? 1 : state.brushSpeed,
      };
    case "set_wipe_speed":
      return {
        ...state,
        wipeSpeed: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_wipe_dir":
      return {
        ...state,
        wipeDirection: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_wipe_count":
      return {
        ...state,
        wipeCount: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_wipe_span":
      return {
        ...state,
        wipeSpan: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_grow_shrink":
      return {
        ...state,
        growShrink: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_pen_path":
      return {
        ...state,
        penSpeed: 40,
        penPath: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_pen_radius":
      return {
        ...state,
        penRadius: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_pen_speed":
      return {
        ...state,
        penSpeed: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "set_shape":
      return {
        ...state,
        shapeSettings: action.value,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "undo":
      const undoHistory = { ...state.history };
      undoHistory.performUndo = !undoHistory.performUndo;
      undoHistory.historyPos = --undoHistory.historyPos;
      return {
        ...state,
        history: undoHistory,
        isColorSelect: false,
        isColorfillMode: false,
      };
    case "redo":
      return state;

    case "set_history_length":
      const historyLength = { ...state.history };
      historyLength.historyLength = action.value;
      historyLength.historyPos = action.value;
      return { ...state, history: historyLength };
    // Sessions reducers
    case "set_movie_auth":
      if (state.userSessionData.session === undefined) return state;
      return {
        ...state,
        movieAuth: action.value,
      };

    case "set_session":
      return {
        ...state,
        userSessionData: {
          session: action.value,
          default_tag: null,
          images: state.userSessionData.images,
        },
      };
    case "clear_sessions":
      return {
        ...state,
        userSessionData: {
          session: undefined,
          default_tag: null,
          images: [],
        },
      };
    case "set_imageList":
      return {
        ...state,
        userSessionData: {
          ...state.userSessionData,
          images: action.value,
        },
      };
    case "set_user_settings":
      return {
        ...state,
        userBrushes: action.value.brush_settings || [],
        userSessionData: {
          ...state.userSessionData,
          default_tag: action.value.default_tag
        }
      }
    default:
      return state;
  }
};
